import { create } from 'zustand';
import React from 'react';

type BillOfMaterialState = {
  data: React.Key[];
  setData: (data: React.Key[]) => void;
  resetSelectedRowKeys: () => void;
};

export const useBillOfMaterialDetailStore = create<BillOfMaterialState>(
  (set) => ({
    data: [],
    setData: (data) => set({ data }),
    resetSelectedRowKeys: () => set({ data: [] }),
  }),
);
